<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link :to="{ name: 'Home' }">Accueil</router-link></li>
        <li
          class="breadcrumb-item active"
          aria-current="page">Dépannage</li>
      </ol>
    </nav>
    <b-row>
      <b-col>
        <b-form-group
          label="Filtrer"
          label-cols-sm="3"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput">
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="Taper pour rechercher un dépannage"/>
            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''">Effacer</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      :fields="fields"
      :items="troubleshoots"
      :filter="filter"
      :filter-included-fields="filterOn"
      small
      responsive="sm">
      <template #cell(tbs_id)="row">
        <b-col>{{ row.item.tbs_id }}</b-col>
      </template>
      <template #cell(esta_internal_name)="row">
        <b-col>{{ row.item.esta_internal_name }}</b-col>
      </template>
      <template #cell(tbs_type)="row">
        <b-badge
          v-if="row.item.tbs_type === 'modu'"
          variant="info">Module</b-badge>
        <b-badge
          v-else-if="row.item.tbs_type === 'par'"
          variant="warning">Résident</b-badge>
        <b-badge
          v-else-if="row.item.tbs_type === 'staf'"
          variant="success">Personnel</b-badge>
      </template>
      <template #cell(help_label)="row">
        <b-col>{{ row.item.help_label }}</b-col>
      </template>
      <template #cell(tbs_status)="row">
        <b-badge
          v-if="row.item.tbs_status === 'CREATED'"
          variant="info">Créé</b-badge>
        <b-badge
          v-else-if="row.item.tbs_status === 'SEND'"
          variant="warning">Envoyé</b-badge>
        <b-badge
          v-else-if="row.item.tbs_status === 'DONE'"
          variant="success">Traité</b-badge>
        <b-badge
          v-else-if="row.item.tbs_status === 'FAIL'"
          variant="danger">Erreur</b-badge>
        <b-badge
          v-else-if="row.item.tbs_status === 'CANCEL'"
          variant="secondary">Annulé</b-badge>
      </template>
      <template #cell(update)="row">
        <b-row>
          <b-col>
            <b-button
              v-if="row.item.tbs_status === 'CREATED'"
              size="sm"
              variant="warning"
              @click="cancelTroubleshoot(row.item)">Annuler</b-button>
          </b-col>
        </b-row>
      </template>
    </b-table>
  </div>
</template>
<script>

import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import { operationBus } from '../main';

export default {
  data() {
    return {
      fields: [
        {
          tbs_id: {
            label: 'Id',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          esta_internal_name: {
            label: 'Etablissement',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          tbs_type: {
            label: 'Type',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          help_label: {
            label: 'Description',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          tbs_status: {
            label: 'Statut',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          reporter: {
            label: 'Rapporteur',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
        {
          update: {
            label: 'Actions',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
      ],
      filter: null,
      filterOn: [],
      edit: -1,
      listToShow: 'staff',
      dupEstablishment: null,
    };
  },
  computed: mapState({
    troubleshoots: state => state.establishments.troubleshoots,
  }),
  created() {
    this.$store.dispatch('establishments/getAllTroubleshoots');
  },
  methods: {
    cancelTroubleshoot(trouble) {
      const operation = {
        id: this.id, // TODO : Generate id
        cancel: false,
        action: `le retrait du dépannage : ${trouble.help_label}`,
        request: 'establishments/cancelTroubleshoot',
        params: { tbs_id: trouble.tbs_id },
      };
      operationBus.$emit('operationAdded', operation);
    },
  },
};
</script>
<style>
</style>
